<template>
    <v-container fluid>
        <v-col lg="12" class="pt-2 pb-1">
            <s-crud add-no-function height="auto" searchInput ref="crudpreviouscontract" title="Contratos Previos"
                @rowSelected="rowSelected" :config="config" :filter="filter" pdf @pdf="printPDF">

                <template v-slot:item.Functions="row">
                    <v-btn small color="primary" class="text-none rounded-lg" @click="openModalFunctions(row.item)">
                        <v-icon left>mdi-file-document</v-icon>
                        Ver Funciones
                    </v-btn>
                </template>

                <template v-slot:options>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text black @click="showImportModal = true" small>
                                <i class="fas fa-file-import"></i>
                            </v-btn>
                        </template>
                        <span>Importar Excel</span>
                    </v-tooltip>
                </template>
            </s-crud>
        </v-col>

        <v-dialog v-if="showImportModal" v-model="showImportModal" width="1200px" persistent>
            <PreviousContractImportModal @close="closeModalAndRefresh()" />
        </v-dialog>

        <!-- Modal anidado para seleccionar Tipo Cultivo -->
        <v-dialog v-model="showFunctionsModal" persistent width="900">
            <v-card class="elevation-5" style="border-radius: 12px; overflow: hidden;">
                <v-card-title class="headline primary gradient-primary white--text"
                    style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
                    <div class="header-left">
                        <v-avatar size="32" color="white" class="mr-4">
                            <v-icon color="primary" size="24">mdi-file-document</v-icon>
                        </v-avatar>
                        <span>Funciones del Contrato</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showFunctionsModal = false" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <template v-if="form">
                    <v-card-text>
                        <div v-html="formatList(form.Functions)"></div>
                    </v-card-text>
                </template>
            </v-card>
        </v-dialog>

        <!-- Modal Impresión PDF -->
        <v-dialog v-if="showModalPDF" v-model="showModalPDF" width="227.7mm" persistent>
            <PreviousContractPDF :form="form" @close="showModalPDF = false" />
        </v-dialog>

    </v-container>
</template>

<script>
import _Service from "@/services/HumanResource/PreviousContractService";
import PreviousContractImportModal from "./PreviousContractImportModal.vue";
import PreviousContractPDF from "./PreviousContractPDF.vue";

export default {
    components: {
        PreviousContractImportModal, PreviousContractPDF
    },
    data() {
        return {
            form: false,
            showModalPDF: false,
            showImportModal: false,
            showFunctionsModal: false,
            filter: {},
            config: {
                model: {
                    PrvcID: "ID",
                    CampaignStartDate: "date",
                    CampaignEndDate: "date",
                    FromDate: "date",
                    ToDate: "date",
                    SecCreate: "date",
                },
                service: _Service,
                headers: [
                    { text: "Documento", value: "Document", sortable: false },
                    { text: "Nombres y Apellidos", value: "Name", width: "180", sortable: false },
                    { text: "Dirección", value: "Address", width: "180", sortable: false },
                    { text: "Distrito", value: "District", sortable: false },
                    { text: "Provincia", value: "Province", sortable: false },
                    { text: "Departamento", value: "Department", sortable: false },
                    { text: "Campaña", value: "Campaign", width: "130", sortable: false },
                    { text: "Inicio de Campaña", value: "CampaignStartDate", sortable: false },
                    { text: "Fin de Campaña", value: "CampaignEndDate", sortable: false },
                    { text: "Desde", value: "FromDate", sortable: false },
                    { text: "Hasta", value: "ToDate", sortable: false },
                    { text: "Monto", value: "Amount", sortable: false },
                    { text: "Monto en Letras", value: "AmountInWords", width: "180", sortable: false },
                    { text: "Ocupación", value: "Occupation", sortable: false },
                    { text: "Cargo del Jefe", value: "SupervisorPosition", width: "130", sortable: false },
                    { text: "Área", value: "Area", sortable: false },
                    { text: "Gerencia", value: "Management", align: "center", sortable: false },
                    { text: "Funciones", value: "Functions", sortable: false },
                    { text: "Día", value: "Day", sortable: false },
                    { text: "Mes", value: "Month", sortable: false },
                    { text: "Fecha Creación", value: "SecCreate", sortable: false }
                ]

            }
        }
    },
    methods: {
        rowSelected(items) {
            this.form = items.length > 0 ? { ...items[0] } : null;
        },
        openModalFunctions(row) {
            this.form = { ...row };
            this.showFunctionsModal = true;
        },
        closeModalAndRefresh() {
            this.showImportModal = false;
            this.$refs.crudpreviouscontract.refresh();
        },
        formatList(text) {
            if (!text) return '';
            const items = text.split('•').map(i => i.trim()).filter(i => i.length);

            return `<ul class="v-list v-list--dense pa-0 ma-0">
                ${items.map(i => `
                <li class="v-list-item pa-0 ma-0 text-left" style="font-size: 10px;">
                   ${i}
                </li>`).join('')}
            </ul>`;
        },
        printPDF() {
            this.showModalPDF = true;
        }
    },
    created() { },
}
</script>